import clsx from "clsx";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { QCM } from "react-sdk/activities/QCM";
import classes from './Qcm.module.css'
// import Catalogue from "@/js/Catalogue/Catalogue";

/**
 *
 * @param {object} props
 * @param {QCM} props.qcm
 * @returns
 */

const QrlInput = ({qcm}) => {


  let isCorrect = qcm.result?.is_correct === true
  let isWrong = qcm.result?.is_correct === false

  // if (qcm.result && qcm.catalogId) {
  //   let catItem = Catalogue.get(qcm.catalogId);
  //   if (catItem) {
  //     if(isWrong)
  //       catItem.knowledge = -1;
  //     else
  //       catItem.knowledge = 1;
  //   }
  // }

  return (
    <div className={clsx(classes.QrlInput_ctnr, isCorrect && classes.correct, isWrong && classes.wrong)}>
      <input
      autoFocus
      className={classes.QrlInput}
      type="text"
      placeholder="Entrez votre réponse ici"
      disabled={qcm.result}
      value={qcm.result?.is_correct ? qcm.choices[0].Text : qcm.QrlAnswer}
      onChange={e => qcm.QrlAnswer = e.target.value}
      onKeyDown={e => {
        if(e.code === "Enter") qcm.localCorrect()
      }}
      />
    </div>
  )
}

export default observer(QrlInput)
